import { render, staticRenderFns } from "./UCSAOrderRedPackets.vue?vue&type=template&id=1ed3ec36&"
import script from "./UCSAOrderRedPackets.vue?vue&type=script&lang=js&"
export * from "./UCSAOrderRedPackets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports